import { createStyles, Theme, Typography, WithStyles, withStyles } from '@freighthub/silhouette-core'
import cn from 'classnames'
import { Component, PropsWithChildren } from 'react'
import { I18N } from 'utils/localisation'

export const testIds = { emptyView: 'empty-view' }

const jssEmptyView = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },
    infoText: {
      color: theme.palette.text.secondary,
      textAlign: 'center',
    },
  })

interface IEmptyViewProps extends WithStyles<typeof jssEmptyView, false> {
  term: string
  small?: boolean
  extraSmall?: boolean
  className?: string
}

class LeanEmptyView extends Component<PropsWithChildren<IEmptyViewProps>> {
  render() {
    const { children, term, small, extraSmall, classes, className } = this.props

    return (
      <Typography data-testid={testIds.emptyView} variant="h6" className={cn(classes.root, className)}>
        {children}
        {!small && !extraSmall && (
          <Typography className={classes.infoText}>
            <I18N term={term} />
          </Typography>
        )}
        {small && (
          <Typography variant="body1" className={classes.infoText}>
            <I18N term={term} />
          </Typography>
        )}
        {extraSmall && <Typography variant="caption" className={classes.infoText} />}
      </Typography>
    )
  }
}

export const EmptyView = withStyles(jssEmptyView)(LeanEmptyView)
